import Sidebar from "./Sidebar";

export default function AdminLayout({ children }) {
  return (
    <div className="min-h-screen flex bg-[#F7F1EA]">
      <Sidebar />

      <div className="flex-1 p-8 overflow-auto">
        {children}
      </div>
    </div>
  );
}